export const GIFT_CARD_TYPE = 1;
export enum status { ENABLED = 1, DISABLED = 2 }